import React, { useState } from 'react';

import { useMutation } from '@betterment/js-runtime';
import { Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Button, Modal } from '@betterment/style-closet-react';

import { trackClick } from '../../features/track';
import { urlBuilder } from '../../Shared/urlBuilder';

type FirmFormCRSProps = {
  firmFormCRSName: string;
  firmFormCRSDocumentURL: string;
  firmFormCRSToken: string;
};

interface FirmFormCRSDeliveryParams {
  token: string;
}

const FirmFormCRSModal: React.FC<FirmFormCRSProps> = ({
  firmFormCRSName,
  firmFormCRSDocumentURL,
  firmFormCRSToken,
}) => {
  const [postFirmFormCRSDelivery] = useMutation<{}, FirmFormCRSDeliveryParams>(
    urlBuilder.markFirmFormCRSDelivered.absolute()
  );
  const [shouldShowFirmCRSModal, setShouldShowFirmCRSModal] = useState(true);
  const closeModal = () => {
    void postFirmFormCRSDelivery({ token: firmFormCRSToken });
    setShouldShowFirmCRSModal(false);
  };

  return (
    <>
      {shouldShowFirmCRSModal && (
        <Modal closeHandler={closeModal} variant="new" data-testid="firmFormCRSModal">
          <Modal.Slot name="heading"> Welcome back</Modal.Slot>
          <Modal.Slot name="content">
            <Text as="p">
              {firmFormCRSName} has a new version of Form CRS. You can review it{' '}
              <SambaAutoLink
                onClick={() => trackClick({ module: 'WelcomeBackModal', name: 'FirmFormCRS' })}
                to={firmFormCRSDocumentURL}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </SambaAutoLink>
              .
            </Text>
          </Modal.Slot>
          <Modal.Slot name="actions">
            <Button onClick={closeModal}>Got it</Button>
          </Modal.Slot>
        </Modal>
      )}
    </>
  );
};

export default FirmFormCRSModal;
